export default "__VITE_ASSET__My7Heh7v__"